// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3vnSZ","requiredAsterisk":"Info_requiredAsterisk__2ScGk"};